import type { FaireProductEntity } from "../../entity_types/product";

export const p_vg6j57tj6d: FaireProductEntity = {
  token: "p_vg6j57tj6d",
  type: "product",
  name: "Stainless Steel Inlaid Zircon Cross Pendant Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/c366173426333f300a6409898e6b040106416ee9a964eb26ccddf6dcdf6cb8c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c7accd5de73e9f075a9b0f7eba06fa6311212cc5724810ab1335c52a578a3de.jpeg",
    "https://cdn.faire.com/fastly/6c9d9878035f3937fbd5fbdf8aef38209c60acc0e180979e75ca17a8f10ebabb.jpeg",
    "https://cdn.faire.com/fastly/53aafab624ce76bd8bda26c6486407698dc103b55862b7e3458fb3c3d6ea8d58.jpeg",
    "https://cdn.faire.com/fastly/07bbd18f90bb0dafd0b9aac97e15c809a0bc176f2e59d406d1ae4f0a39ff821d.jpeg",
  ],
  priceDollars: 6.44,
  description:
    "\n Material: Stainless Steel, Gold Plated, Cubic Zirconia \n\n Chain Length: 450mm + 50mm / 17.71inch + 1.97inch\n\n Pendant Size: 0.99inch * 0.63inch\n\n★Made of high quality stainless steel，Lead-free ，Harmless to Human Body.\n\n★Perfect jewelry gift\n      \n\n\n",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:28.136Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
